import { get } from 'lodash';
import withDraft from '@/utils/draftHelper';
import actions from '@/roles/constants';
import { assignValue } from '@/utils/resultsHelper';

const updateRoleName = withDraft((draft, { code, result: { name } }) => {
  ['open'].forEach((category) => {
    const { results } = draft.userGroups[category];
    results.forEach(({ users }) => {
      const matches = users.results.filter((r) => (get(r, 'role.code') === code));
      matches.forEach(({ role }) => { assignValue(role, 'name', name); });
    });
  });
});

export default {
  [actions.EDIT_ROLE_SUCCESS]: updateRoleName,
};
